import { IssueMedia } from './issue.dto';
import { Observable } from 'rxjs';
import { ChangeTyped } from '@damofire/data-commons';

export abstract class ObservableIssueMediaService {
  abstract observeMediaByIssue(division: string, issueId: string): Observable<ChangeTyped<IssueMedia>[]>;
}
